module.exports = __webpack_public_path__ + "static/media/icons8-bumblebee-480.e26d6660.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-bumblebee/dark/icons8-bumblebee-480.png
// module id = 1896
// module chunks = 2